import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { createApp } from "vue-demi";
import "./index-CgZzOVq6.js";
import "./index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { X as XAlert, u as usePositions, D as DURATION_EXTRA_BUFFER } from "./XAlert-C6ysGEVR.js";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-VvYS6rEj.js";
const toast = "_toast_13s10_1";
const isTopRight = "_isTopRight_13s10_10";
const isTopLeft = "_isTopLeft_13s10_14";
const isBottomRight = "_isBottomRight_13s10_18";
const isBottomLeft = "_isBottomLeft_13s10_22";
const style0 = {
  toast,
  isTopRight,
  isTopLeft,
  isBottomRight,
  isBottomLeft
};
const { createPositionProp, getCurrentPositionClass } = usePositions();
const __default__ = {
  name: "XToast",
  components: { XAlert }
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    offsetY: {
      type: String,
      default: null
    },
    offsetX: {
      type: String,
      default: null
    },
    ...createPositionProp()
  },
  setup(__props) {
    const props = __props;
    const toastStore = useToastStore();
    const { positionClass } = getCurrentPositionClass(props);
    const toasts = computed(() => toastStore.toasts[props.position].list);
    const containerId = computed(() => toastStore.getContainerId(props.position));
    const customOffsets = computed(() => ({
      "--offset-x": props.offsetX,
      "--offset-y": props.offsetY
    }));
    function handleClose(toast2) {
      toastStore.removeToast(toast2);
    }
    return { __sfc: true, createPositionProp, getCurrentPositionClass, props, toastStore, positionClass, toasts, containerId, customOffsets, handleClose, XAlert };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { directives: [{ name: "show", rawName: "v-show", value: _setup.toasts.length > 0, expression: "toasts.length > 0" }], class: [_vm.$style.toast, _setup.positionClass], style: _setup.customOffsets, attrs: { "id": _setup.containerId } }, _vm._l(_setup.toasts, function(toast2) {
    return _c(_setup.XAlert, _vm._b({ key: toast2.id, attrs: { "model": "toast", "position": _vm.position }, on: { "close": function($event) {
      return _setup.handleClose(toast2);
    } } }, "XAlert", toast2, false), [_vm._v(_vm._s(toast2.message))]);
  }), 1);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XToast = __component__.exports;
const useToastStore = defineStore("XToast", () => {
  const { POSITIONS } = usePositions();
  const baseConfigs = ref({
    position: POSITIONS.topRight,
    offsetY: null,
    offsetX: null
  });
  const toasts = ref(
    Object.fromEntries(
      Object.values(POSITIONS).map((position) => [
        position,
        { list: [], container: null, instance: null }
      ])
    )
  );
  function getToastProps(configOptions) {
    return {
      ...baseConfigs.value,
      ...configOptions
    };
  }
  function addToast(message, configOptions = {}) {
    const props = getToastProps(configOptions);
    const { position } = props;
    mountInstance(props);
    const id = Date.now();
    toasts.value[position].list.unshift({
      id,
      message,
      closable: true,
      ...props
    });
  }
  function unmountInstance(position) {
    const { container, instance } = toasts.value[position];
    if (container) {
      container.remove();
      toasts.value[position].container = null;
    }
    if (instance) {
      instance.unmount();
      toasts.value[position].instance = null;
    }
  }
  function removeToast(toast2) {
    setTimeout(() => {
      const position = toast2.position;
      toasts.value[position].list = toasts.value[position].list.filter((t) => t.id !== (toast2 == null ? void 0 : toast2.id));
      if (toasts.value[position].list.length <= 0) {
        unmountInstance(position);
      }
    }, DURATION_EXTRA_BUFFER);
  }
  function getContainerId(position) {
    return `toast-container-${position}`;
  }
  function mountInstance(props) {
    const { position, offsetY, offsetX } = props;
    if (toasts.value[position].container) return;
    const instance = createApp(XToast, {
      position,
      offsetY,
      offsetX
    });
    const instanceContainer = document.createElement("div");
    instanceContainer.id = getContainerId(position);
    document.body.appendChild(instanceContainer);
    instance.mount(instanceContainer);
    toasts.value[position].container = document.getElementById(getContainerId(position)) || instanceContainer;
    toasts.value[position].instance = instance;
  }
  return { toasts, addToast, removeToast, getContainerId };
});
export {
  XToast as X,
  useToastStore as u
};
